module.exports = __webpack_public_path__ + "static/media/main_bgMofi.6d3e4327.png";